import React, { useState } from 'react';
import { AiOutlineAudio, AiOutlineClose, AiOutlineMenu} from 'react-icons/ai';
import { Link } from 'react-router-dom';
import { CiHome, CiCircleInfo} from 'react-icons/ci'
import citylogo from '../assets/citylogo.png'
const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

 

  return (
    <nav className=" bg-blue-950">
      <div className="max-w-screen ">
        <div className="flex items-center justify-between h-16 mr-[16px] ml-[-10px] md:mr-[60px] md:ml-[30px] lg:ml-[80px] lg:mr-[120px]">
          {/* mobile */}
          <div className='w-full md:hidden flex justify-between md:justify-center items-center'>
            <Link to={'/'}><img alt='new' src={citylogo} className='w-[150px] h-[150px] mb-2 object-cover'/></Link>
            <div onClick={() => setIsMenuOpen(!isMenuOpen)} className='text-white md:hidden cursor-pointer hover:border rounded-lg border-indigo-600 p-2'>
              <AiOutlineMenu size={24} />
            </div>
          </div>
          {/* desktop */}
          <div className='hidden md:flex justify-between md:justify-center items-center'>
            <div onClick={() => setIsMenuOpen(!isMenuOpen)} className='text-white md:hidden cursor-pointer'>
              <AiOutlineMenu size={24} />
            </div>
            <Link to={'/'}><img alt='new' src={citylogo} className='w-[150px] h-[150px] mb-2 object-cover'/></Link>
          </div>
          {/* desktop */}
          <div className="hidden md:block">
            <div className="ml-4 flex items-center space-x-4">
              <a href="/" className="text-gray-300 hover:bg-blue-950 hover:text-white px-3 py-2 rounded-md text-sm font-medium">
                Home
              </a>
              <Link to={'/about'}>
                <div className="text-gray-300 hover:bg-blue-950 hover:text-white px-3 py-2 rounded-md text-sm font-medium">
                  About
                </div>
              </Link>
              <Link to={'/videos'}>
                <div className="text-gray-300 hover:bg-blue-950 hover:text-white px-3 py-2 rounded-md text-sm font-medium">
                  Videos
                </div>
              </Link>


              <Link to={'/admin'}>
                <div href="/contact" className="text-gray-300 hover:bg-blue-950 hover:text-white px-3 py-2 rounded-md text-sm font-medium">
                  Give Online
                </div>
              </Link>


              
            </div>
          </div>  
        </div>  
      </div>
      {/* mobile */}
        {isMenuOpen ? <div className='bg-black/80 fixed w-full h-screen z-10 top-0 left-0 md:hidden'></div> : ''}

      <div className={isMenuOpen ? 'fixed top-0 left-0 w-[280px] h-screen bg-blue-950 z-10 duration-300 md:hidden' : ' fixed top-0 left-[-150%] w-[280px] h-screen bg-blue-100  z-10 duration-300 md:hidden'}>
       <div  className='hover:border rounded-lg border-blue-950 absolute left-4 top-4 cursor-pointer p-2'> 
        <AiOutlineClose onClick={() => setIsMenuOpen(!isMenuOpen)} size={24} className='bg-white'/>
        </div>
        <nav>
          <ul className='flex flex-col p-4 text-white pt-[5em]'>
            <Link to={'/'}><li className='text-xl py-4 flex'><CiHome size={25} className='mr-4' /> Home </li></Link>
            <Link to={'/about'}><li className='text-xl py-4 flex'><CiCircleInfo size={25} className='mr-4' /> About </li></Link>

            <Link  to={'/admin'}>
              <li className='text-xl py-4 flex'><AiOutlineAudio size={25} className='mr-4' />Give Online</li>
            </Link>
            
          </ul>
        </nav>
      </div> 
    </nav>
  );
};

export default Navbar;
